import { findFontRecord, makeFontKey } from '../components/InteractiveRenderer/FontsLoader';
export var generateFontString = function (isBold, isItalic, fontSize, fontFamily) {
    var resString = '';
    if (isBold) {
        resString += 'bold ';
    }
    if (isItalic) {
        resString += 'italic ';
    }
    resString += "".concat(fontSize, "px ").concat(fontFamily);
    return resString;
};
export var detectAllFonts = function (sections) {
    var res = {};
    for (var secId in sections) {
        var section = sections[secId];
        if (section.text) {
            var key = makeFontKey(section.font, section.isBold, section.isItalic);
            var fontRecord = findFontRecord(key);
            if (!fontRecord) {
                console.error("Font used in Section ".concat(secId, " is not available: ").concat(key));
            }
            else {
                res[key] = fontRecord;
            }
        }
    }
    return res;
};
export var getSectionControlSize = function (data) {
    var sectionWidth = data.sectionWidth, sectionHeight = data.sectionHeight, scaleCoef = data.scaleCoef;
    var coef = 0.6;
    var dotWidth = 0;
    if (sectionWidth > sectionHeight) {
        dotWidth = sectionHeight * coef * scaleCoef;
    }
    else {
        dotWidth = sectionWidth * coef * scaleCoef;
    }
    if (dotWidth > 10) {
        dotWidth = 10;
    }
    else if (dotWidth < 5) {
        dotWidth = 5;
    }
    return dotWidth / scaleCoef;
};
